/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import _ from 'lodash';
import { normalizePatient } from '../../models/patient';
import { Patient } from '../../backendModels/patient.model';
import { normalizeMissionData, sanitizeMission } from '../../models/operational';
import { MissionData } from '../../backendModels/mission-data.model';
import { SynchronizedBaseData, SynchronizedMissionData } from '../../models/diviDataUpdate';
import { controlCenterPropertiesOfMissionDataForPatientMaster } from '../Pages/PatientMasterData/PatientMasterData.functions';
import {
  excludedMissionDataPropertiesForOperational,
  excludedParticipantsProperties,
} from '../Pages/OperationalData/operationalData.utils';

export function isEqualPatient(
  patient: Patient | undefined,
  lastSynchronizedBaseData: SynchronizedBaseData | undefined
) {
  return _.isEqual(
    normalizePatient(_.omit(patient, ['symptomOnset'])),
    normalizePatient(_.omit(lastSynchronizedBaseData?.patient, ['symptomOnset']))
  );
}

export function isEqualPatientSymptomOnset(
  patient: Patient | undefined,
  lastSynchronizedBaseData: SynchronizedBaseData | undefined
) {
  return _.isEqual(
    normalizePatient(_.pick(patient, ['symptomOnset'])),
    normalizePatient(_.pick(lastSynchronizedBaseData?.patient, ['symptomOnset']))
  );
}

/*
Checks only the mission data displayed in DIVI's Operational ("Einsatztechnische Daten") section, i.e. except the
mission data of PatientMaster (see {@link isEqualMissionDataPatientMaster}).
 */
export function isEqualMissionDataOperational(
  missionData: MissionData | undefined,
  lastSynchronizedMissionData: SynchronizedMissionData | undefined
) {
  return _.isEqual(
    normalizeMissionData(_.omit(missionData, ['controlCenter', ...excludedParticipantsProperties])),
    sanitizeMission(_.omit(lastSynchronizedMissionData?.mission, excludedMissionDataPropertiesForOperational))
  );
}

/*
Checks only the mission data displayed in DIVI's PatientMaster ("Pat-Stammdaten") section, i.e. control center
information of MissionData (control center, location and personnelNumber).
 */
export function isEqualMissionDataPatientMaster(
  missionData: MissionData | undefined,
  lastSynchronizedMissionData: SynchronizedMissionData | undefined
) {
  return _.isEqual(
    normalizeMissionData(_.pick(missionData, ['controlCenter'], controlCenterPropertiesOfMissionDataForPatientMaster)),
    sanitizeMission(_.pick(lastSynchronizedMissionData?.mission, controlCenterPropertiesOfMissionDataForPatientMaster))
  );
}
